import { call, put, takeEvery, select } from 'redux-saga/effects';
import { matchPath } from 'connected-react-router';
import { LOCATION_CHANGE } from 'connected-react-router';
import { actions, constants, selector } from './index';
import authSelector from '../authorization/selector';
import Api from '../../utils/Api';

export function* fetchItems() {
  try {
    const authState = yield select(authSelector);
    const id = authState.data ? authState.data.id : localStorage.getItem('clientId');
    const data = yield call(Api.assignedVessels.index, id);

    yield put(actions.addItems(data));
  } catch (e) {
    console.error(e);

    yield put(actions.loadItemsError(e));
  }
}

export function* createItem({ payload: id }) {
  try {
    const { data } = yield call(Api.assignedVessels.create, id);

    yield put(actions.addCreatedItem(data));
  } catch (e) {
    yield put(actions.createItemError(e));
  }
}

export function* deleteItem({ payload }) {
  try {
    yield call(Api.assignedVessels.delete, payload.select_vessel_id);
    yield put(actions.deleteItem(payload));
  } catch (e) {
    yield put(actions.deleteItemError(e));
  }
}

export function* fetchItemsPageInit({ payload: { location: { pathname, state } } }) {
  // history v5 defaults `location.state` to `null` (vs RR5 + history
  // v4's `undefined`). Default-value destructuring (`= {}`) only
  // triggers on `undefined`, so the legacy form
  //   `state: { doWeNeedToReloadData } = {}`
  // crashes with "Cannot destructure of '{}' as it is null". Pull
  // the field via optional chaining instead.
  const doWeNeedToReloadData = state?.doWeNeedToReloadData;
  const { didLoad, isLoading } = yield select(selector);

  // Wherever <Planning /> is the background page — `/` and every
  // `/timeplans/*` URL in routes.jsx — the board sits on a splash screen
  // until these vessels land, and nothing else starts the load. Matching
  // only `/` and `/timeplans/:id/edit` left `/timeplans` typed directly,
  // and F5 on a crew-change edit URL, spinning forever with an empty
  // console (2026-09-02). The shim's matchPath without `exact` is a prefix
  // match, so one pattern covers every overlay under /timeplans, including
  // the ones not written yet.
  const isPageOpened = (
    matchPath(pathname, { path: '/', exact: true })
    || matchPath(pathname, { path: '/timeplans' })
  );

  // `!isLoading`: the first render of `/timeplans/new` now matches too, and
  // redirectIfReloadNewForm pushes `/` right behind it. Without the guard
  // that second LOCATION_CHANGE would fire a second request while the first
  // is still in flight. An explicit reload request still goes through.
  const needsLoad = (!didLoad && !isLoading) || doWeNeedToReloadData;

  if (isPageOpened && needsLoad) yield put(actions.loadItemsRequest());
}

/**
 * getFeatureSagas (rename)
 * each saga file should return all feature sagas
 * @returns {ForkEffect[]}
 */
export default function getFeatureSagas() {
  return [
    takeEvery(constants.LOAD_ITEMS_REQUEST, fetchItems),
    takeEvery(constants.CREATE_ITEM_REQUEST, createItem),
    takeEvery(constants.DELETE_ITEM_REQUEST, deleteItem),
    takeEvery(LOCATION_CHANGE, fetchItemsPageInit),
  ];
}
